import { useDebouncedValue } from "@mantine/hooks";
import {
	type ReactNode,
	createContext,
	useContext,
	useMemo,
	useState,
} from "react";

interface SearchContextType {
	query: string;
	searchQuery: string;
	setSearchQuery: (value: string) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

SearchContext.displayName = "SearchContext";

export function SearchProvider({ children }: { children: ReactNode }) {
	const [searchQuery, setSearchQuery] = useState("");
	const [query] = useDebouncedValue(searchQuery, 300);

	const value = useMemo(() => {
		return { query, searchQuery, setSearchQuery };
	}, [query, searchQuery]);

	return (
		<SearchContext.Provider value={value}>{children}</SearchContext.Provider>
	);
}

export function useSearch() {
	const context = useContext(SearchContext);
	if (context === undefined) {
		throw new Error("useSearch must be used within a SearchProvider");
	}
	return context;
}
